import { render, staticRenderFns } from "./rule_add.vue?vue&type=template&id=20690fd0&scoped=true"
import script from "./rule_add.vue?vue&type=script&lang=js"
export * from "./rule_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20690fd0",
  null
  
)

export default component.exports